import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Tickets from './pages/Tickets.jsx';
import BaseConhecimento from './pages/BaseConhecimento.jsx';
import RelatorioIndicacoes from './pages/RelatorioIndicacoes.jsx';
import DashboardHome from './pages/DashboardHome.jsx';
import Financeiro from './pages/Financeiro.jsx';
import Configuracoes from './pages/Configuracoes.jsx';
import AdminLayout from './components/AdminLayout.jsx';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (token) return <Navigate to="/" replace />;
  return children;
};

// Helper para envolver cada página com o layout + título
const Page = ({ title, subtitle, children }) => (
  <ProtectedRoute>
    <AdminLayout pageTitle={title} pageSubtitle={subtitle}>{children}</AdminLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />

        <Route path="/" element={
          <Page title="Dashboard" subtitle="Visão geral do seu negócio">
            <DashboardHome />
          </Page>
        } />

        <Route path="/clientes" element={
          <Page title="Clientes" subtitle="Gerencie assinaturas, cobranças e módulos">
            <Dashboard />
          </Page>
        } />

        <Route path="/financeiro" element={
          <Page title="Financeiro" subtitle="Saúde do Mercado Pago, webhooks e reconciliação">
            <Financeiro />
          </Page>
        } />

        <Route path="/tickets" element={
          <Page title="Tickets" subtitle="Atendimento e suporte aos clientes">
            <Tickets />
          </Page>
        } />

        <Route path="/base-conhecimento" element={
          <Page title="Base de Conhecimento" subtitle="Artigos e documentação para os clientes">
            <BaseConhecimento />
          </Page>
        } />

        <Route path="/relatorios/indicacoes" element={
          <Page title="Indicações" subtitle="Relatório de clientes indicados">
            <RelatorioIndicacoes />
          </Page>
        } />

        <Route path="/configuracoes" element={
          <Page title="Configurações" subtitle="Serviços, produtos e ajustes do painel">
            <Configuracoes />
          </Page>
        } />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
